import { Form, Link } from '@remix-run/react';

export const Free = ({ isCurrent }: { isCurrent: boolean; }) => {
	return (
		<li className={`pricing-tier ${isCurrent ? 'current' : ''}`}>
			<h2 className="pricing-tier--heading">Starter</h2>
			<p>The starter tier includes 1 group and up to 5 group lists with an unlimited number of list items.</p>
			<h3 className="pricing-tier--cost">Free forever <span className="pricing-tier--cost_conditions">1 group and up to 5 lists</span></h3>
			{isCurrent ? <p className="pricing-tier--current">Your current tier</p> : <p className="pricing-tier--link">
				<Link to="/account/join" className="button">Sign up now</Link>
			</p>}
		</li>
	);
};

export const Basic = ({ isCurrent, isLoggedIn }: { isCurrent: boolean; isLoggedIn: boolean; }) => {
	return (
		<li className={`pricing-tier ${isCurrent ? 'current' : ''}`}>
			<h2 className="pricing-tier--heading">Basic</h2>
			<p>The basic tier offers everything in the starter tier plus up to 3 groups.</p>
			<h3 className="pricing-tier--cost">£4.99 <span className="pricing-tier--per">per month</span> <span className="pricing-tier--cost_conditions">3 groups and up to 5 lists per group</span></h3>
			{isCurrent ? <p className="pricing-tier--current">Your current tier</p> : <Form method="post" action="/account/buy" className="pricing-tier--link">
				<input type="hidden" name="lookup_key" value="basic" />
				<button type="submit" className="button">{isLoggedIn ? 'Upgrade plan' : 'Buy plan'}</button>
			</Form>}
		</li>
	)
};

export const Full = ({ isCurrent, isLoggedIn }: { isCurrent: boolean; isLoggedIn: boolean; }) => {
	return (
		<li className={`pricing-tier ${isCurrent ? 'current' : ''}`}>
			<h2 className="pricing-tier--heading">Advanced</h2>
			<p>The advanced tier offers an unlimited number of groups and group lists/members</p>
			<h3 className="pricing-tier--cost">£6.99 <span className="pricing-tier--per">per month</span> <span className="pricing-tier--cost_conditions">Unlimited groups and lists</span></h3>
			{isCurrent ? <p className="pricing-tier--current">Your current tier</p> : <Form method="post" action="/account/buy" className="pricing-tier--link">
				<input type="hidden" name="lookup_key" value="full" />
				<button type="submit" className="button">{isLoggedIn ? 'Upgrade plan' : 'Buy plan'}</button>
			</Form>}
		</li>
	);
};
